<template>
  <div class="ai-visibility-error-state">
    <div>
      <h2>Something went wrong</h2>
      <p>{{ message }}</p>
    </div>
    <button
      v-if="showRetry"
      type="button"
      @click="$emit('retry')"
    >
      {{ retryLabel }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'ErrorState',
  props: {
    message: {
      type: String,
      required: true,
    },
    retryLabel: {
      type: String,
      default: 'Try again',
    },
    showRetry: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style lang="scss" scoped>

.ai-visibility-error-state {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  border: 1px solid var(--v-red4Color-base);
  border-radius: 8px;
  background: var(--v-red6Color-base);
  color: var(--v-mainColor-base);
  padding: 20px;
}

.ai-visibility-error-state h2 {
  color: var(--v-red11Color-base);
  font-size: 16px;
  font-weight: 800;
  margin: 0 0 6px;
}

.ai-visibility-error-state p {
  font-size: 14px;
  line-height: 1.45;
  margin: 0;
}

.ai-visibility-error-state button {
  min-height: 38px;
  border: 1px solid var(--v-red11Color-base);
  border-radius: 999px;
  background: var(--v-cardBg-base);
  color: var(--v-red11Color-base);
  cursor: pointer;
  flex: 0 0 auto;
  font-size: 13px;
  font-weight: 800;
  padding: 0 16px;
}

.ai-visibility-error-state button:focus {
  outline: 2px solid var(--v-lightYellowColor-base);
  outline-offset: 2px;
}
</style>
